
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.004 14c-3.864 0-7-3.129-7-7 0-3.864 3.136-7 7-7 3.87 0 7 3.136 7 7 0 3.871-3.13 7-7 7zm2.233-4.403a.52.52 0 00.721-.182.527.527 0 00-.182-.72L7.284 7.21V3.976a.524.524 0 10-1.05 0v3.535c0 .182.098.35.259.448l2.744 1.638z","fill":"#fff"}})])
          )
        }
      }
    